class TimePeriod {
    constructor(startDate, endDate){
        this.startDate = startDate;
        this.endDate = endDate;
    }

    containsDate(date = new Date()) {
        try{
            if(!this.startDate || !this.endDate){
                return false;
            }
            
            var start = this.startDate.getTime();
            var end = this.endDate.getTime();
            date = date.getTime();
    
            return date >= start && date <= end;
        } catch(err){
            console.error('Error when get time period', err)
        }
    }
}

module.exports = TimePeriod